import { Theme } from "@mui/material/styles"

export const spacing = (theme: Theme) => ({
    gutterBottom__sm: {
        marginBottom: theme.spacing(1.5),
    },
    gutterBottom__md: {
        marginBottom: theme.spacing(2),
    },
    gutterBottom__lg: {
        marginBottom: theme.spacing(4),
    },
})
